import { ageMax, getAge, IsNullOrEmpty, MAX_AGE_EMANCIPATION, MIN_AGE_EMANCIPATION, parseDate } from '../';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
require('dayjs/locale/fr');
dayjs.extend(duration);
export const frenchDate = (value) => {
    if (IsNullOrEmpty(value)) {
        return 'La valeur est vide ou nulle';
    }
    const dateArr = value.replace(/\s/g, '').split('/');
    if (dateArr.length !== 3 || dateArr[2].length !== 4) {
        return "Le format de date n'est pas JJ-MM-AAAA";
    }
    const day = parseInt(dateArr[0]);
    if (day > 31 || day < 1) {
        return "Le jour saisi n'est pas valide";
    }
    const month = parseInt(dateArr[1]);
    if (month > 12 || month < 1) {
        return "Le mois saisi n'est pas valide";
    }
    const year = parseInt(dateArr[2]);
    const currentYear = new Date().getFullYear();
    if (year > currentYear + ageMax || year < currentYear - ageMax) {
        return "L'année saisie n'est pas valide";
    }
    return true;
};
export const affiliationBirthDate = (value) => {
    const dateArr = value.replace(/\s/g, '').split('/');
    const day = parseInt(dateArr[0]);
    if (day > 31 || day < 1) {
        return "Le jour saisi n'est pas valide";
    }
    const month = parseInt(dateArr[1]);
    if (month > 12 || month < 1) {
        return "Le mois saisi n'est pas valide";
    }
    const year = parseInt(dateArr[2]);
    const currentYear = new Date().getFullYear();
    const originYear = currentYear - 75;
    if (year > currentYear - 16 || year < originYear) {
        return "L'année saisie n'est pas valide";
    }
    return true;
};
export const isNotInFutur = (value) => {
    const dateArr = value.replace(/\s/g, '').split('/');
    const day = parseInt(dateArr[0]);
    const month = parseInt(dateArr[1]);
    const year = parseInt(dateArr[2]);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const currentDay = currentDate.getDate();
    if (year > currentYear ||
        (currentYear === year && month > currentMonth) ||
        (currentYear === year && month === currentMonth && day > currentDay)) {
        return 'La date ne peut être postérieure à la date du jour.';
    }
    return true;
};
export const allDates = (value) => {
    const dateArr = value.replace(/\s/g, '').split('/');
    const day = parseInt(dateArr[0]);
    if (day > 31 || day < 1) {
        return "Le jour saisi n'est pas valide";
    }
    const month = parseInt(dateArr[1]);
    if (month > 12 || month < 1) {
        return "Le mois saisi n'est pas valide";
    }
    const year = parseInt(dateArr[2]);
    const currentYear = new Date().getFullYear();
    const originYear = currentYear - 75;
    if (year < originYear) {
        return "L'année saisie n'est pas valide";
    }
    return true;
};
export const isEmancipationAyd = (birthdate, dateEmancipation) => {
    // avoir entre 16 et 18 ans
    if (!dateEmancipation || !birthdate)
        return null;
    const age = getAge(parseDate(birthdate), parseDate(dateEmancipation));
    if (age >= MIN_AGE_EMANCIPATION && age < MAX_AGE_EMANCIPATION) {
        return true;
    }
    return false;
};
